export default {
  easyLanguage: 'Easy Language',
  videoDoesNotYetExist: 'Video does not yet exist'
}



// WEBPACK FOOTER //
// ./src/i18n/common/en.js